var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.chartTypeCheck.includes(_vm.charttype)
    ? _c("div", [_vm._v("CHART TYPE ERROR")])
    : _vm.charttype === "pie_description" ||
      this.charttype === "pie_description_percentage"
    ? _c("div", { class: `chart-pie-description__container` }, [
        _c(
          "div",
          { staticClass: "chart-pie__description" },
          [
            _c("p", [_vm._v(_vm._s(_vm.charttitle))]),
            _vm._v(" "),
            _vm._l(_vm.seriesData, function (series) {
              return _c(
                "div",
                {
                  key: series.name,
                  staticClass: "chart-pie__description-wrapper",
                },
                _vm._l(series.data, function (data) {
                  return _c(
                    "div",
                    {
                      key: data.name,
                      staticClass: "chart-pie__description-line",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "chart-pie__description-color" },
                        [
                          _c("svg", { attrs: { width: "18", height: "18" } }, [
                            _c("circle", {
                              attrs: {
                                cx: "9",
                                cy: "9",
                                r: "9",
                                fill: data.colour,
                              },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "chart-pie__description-name" },
                        [_vm._v(_vm._s(data.name))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "chart-pie__description-number" },
                        [_vm._v(_vm._s(data.y))]
                      ),
                    ]
                  )
                }),
                0
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c("figure", [
          _c("div", {
            ref: "chart",
            class: `chart-${_vm.chartTypeClass}__chart`,
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c("figcaption", { staticClass: "sr-only" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.charttitle) +
                " - " +
                _vm._s(_vm.categories) +
                " - " +
                _vm._s(_vm.seriesData) +
                "\n    "
            ),
          ]),
        ]),
      ])
    : _c("figure", { class: `chart-${_vm.chartTypeClass}__container` }, [
        _c("div", {
          ref: "chart",
          class: `chart-${_vm.chartTypeClass}__chart`,
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("figcaption", { staticClass: "sr-only" }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.charttitle) +
              " - " +
              _vm._s(_vm.categories) +
              " - " +
              _vm._s(_vm.seriesData) +
              "\n  "
          ),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }